import {inject, Injectable} from '@angular/core';
import {STORAGE_CONFIG} from '../core/constants';

@Injectable({
  providedIn: 'root'
})
export class StorageService {


  private storageKey = inject(STORAGE_CONFIG)

  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  setItemSession(value: string): void {
    localStorage.setItem(this.storageKey.session, value);
  }

  setUserSession(value: string): void {
    localStorage.setItem(this.storageKey.user, value);
  }

  clearSession(): void {
    localStorage.removeItem(this.storageKey.session);
  }


  clearUser(): void {
    localStorage.removeItem(this.storageKey.user);
  }


  clear() {
    localStorage.clear();
    sessionStorage.clear();
  }

  setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }
}
